import { ChangeDetectionStrategy, Component, DestroyRef, Signal, computed, effect, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';

import { BlockDirective, ElemDirective } from '@rt-tools/core';
import { RtButtonDirective } from '@rt-tools/ui-kit-v2';
import { PageHeaderComponent } from '@stair-craft/common/components';
import { PageHeaderService } from '@stair-craft/common/util';

const BEM_BLOCK: string = 'sc-catalog-item-page';

@Component({
    selector: 'sc-catalog-item-page',
    templateUrl: './catalog-item-page.component.html',
    styleUrl: './catalog-item-page.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        // rt-tools
        BlockDirective,
        ElemDirective,
        RtButtonDirective,

        // components
        PageHeaderComponent,
    ],
    host: {
        class: BEM_BLOCK,
    },
})
export default class CatalogItemPageComponent {
    readonly #route: ActivatedRoute = inject(ActivatedRoute);
    readonly #router: Router = inject(Router);
    readonly #pageHeader: PageHeaderService = inject(PageHeaderService);
    readonly #params: Signal<ParamMap | undefined> = toSignal(this.#route.paramMap);

    protected readonly slug: Signal<string | null> = computed(() => this.#params()?.get('slug') ?? null);

    constructor() {
        effect((): void => {
            const slug: string | null = this.slug();
            this.#pageHeader.setLeaf(slug ? slug.charAt(0).toUpperCase() + slug.slice(1) : null);
        });
        inject(DestroyRef).onDestroy((): void => {
            this.#pageHeader.setLeaf(null);
        });
    }

    protected useInConstructor(): void {
        const slug: string | null = this.slug();
        if (!slug) {
            return;
        }
        void this.#router.navigate(['/calc/straight'], { queryParams: { material: slug } });
    }
}
